import { CONDITION_TYPE, VALIDATE } from '@cognitiv/cicada-ui';
import { ProjectParameters } from 'ducks/types/store-types';
import { UnionFromArray } from 'ducks/types/type-helpers';

export const parameters_default_state: UnionFromArray<ProjectParameters> = {
  parameter_name: '',
  parameter_direction_id: 1,
  description: '',
  parameter_method_id: 1,
  parameter_method_name: 'Command Line',
  is_required: false,
  parameter_value: '',
  command_line_assignment_char: '=',
  command_line_escaped: true,
  command_line_ignore_name: false,
  command_line_prefix: '--',
  is_encrypted: false,
  reference_type_id: null,
  reference_id: null,
  reference_parameter_name: '',
  owner_id: null,
  parameter_direction_name: '',
  reference_type_name: '',
  reference_name: '',
  modified: false,
  saved: false,
  delete: false,
  parameter_value_disabled: false,
  uuid: '',
};

export const parameter_validation = {
  parameter_name: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Parameter Name is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
  parameter_value: {
    type: VALIDATE.STRING,
    conditions: [
      {
        error: 'Value is required',
        type: CONDITION_TYPE.MIN_LENGTH,
        values: [1],
      },
    ],
  },
};
